import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SettingsService } from '@core/services/settings.service';
import { ProductEncodeSplashesViewModel } from '@models/api.models';
import { BurdSameDayDeliveryService } from '@shared/same-day-delivery/burd-same-day-delivery.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Pipe({
    name: 'sameDayDelivery',
    standalone: true
})
export class SameDayDeliveryPipe implements PipeTransform {
    constructor(private settingsService: SettingsService, private sameDayDeliveryService: BurdSameDayDeliveryService) {}

    // we should only show when the burd delivery is not allowed for the product
    transform(sameDayDelivery?: boolean): Observable<ProductEncodeSplashesViewModel | undefined> {
        // if it's available for same-day delivery, we should return undefined
        if (sameDayDelivery) {
            return of(undefined);
        }

        return this.settingsService.settings$.pipe(
            map(({ productSettings }) =>
                productSettings?.encodeSplashes.find(encodeSplash => encodeSplash.encodeId === 'SameDayDelivery')
            ),
            switchMap(splash =>
                this.sameDayDeliveryService.sameDayDeliveryState.pipe(map(status => ({ status, splash })))
            ),
            map(({ status, splash }) => (status ? splash : undefined)),
            untilDestroyed(this)
        );
    }
}
